import type { CarePlan, CarePlanAdl } from '@lmc/ts-common'
import * as types from '../common/types'

export const setResidentAdls = (adls: CarePlanAdl[]) => ({
  type: types.SET_RESIDENT_ADLS,
  adls
})

export const setCarePlanSortType = (carePlanSortType: string | null) => ({
  type: types.SET_CARE_PLAN_SORT_TYPE,
  carePlanSortType
})

export const setCarePlanHistory = (history: CarePlan[]) => ({
  type: types.SET_CARE_PLAN_HISTORY,
  history
})

export const setCarePlanHistoryDateRange = (
  historyDateRange: [Date, Date]
) => ({
  type: types.SET_CARE_PLAN_HISTORY_DATE_RANGE,
  historyDateRange
})

export const setRiskAssessmentSortType = (
  riskAssessmentSortType: number | null
) => ({
  type: types.SET_RISK_ASSESSMENT_SORT_TYPE,
  riskAssessmentSortType
})
